import {initialState} from "./state"

export const setHasFinanceData = (state, payload) => {
  state.hasFinanceData = payload
}

export const setFinanceData = (state, payload) => {
  state.financeData = payload
}

export const setPodcastRevenue = (state, payload) => {
  state.podcastRevenue = payload
  state.isPodcastRevenueAvailable = payload !== null
}

export const setPodcastRevenueByPodcast = (state, payload) => {
  state.podcastRevenueByPodcast = payload
}

export const setInvoiceSettings = (state, payload) => {
  state.invoiceSettings = payload
}

export const setFinancePeriod = (state, { from, to, frequency }) => {
  state.financePeriod = { from, to }
  state.financeFrequency = frequency
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}
